import { useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '../components/templates/AuthLayout';
import { Alert } from '../components/atoms/Alert/Alert';
import { Button } from '../components/atoms/Button/Button';
import { Stack } from '../components/atoms/Stack/Stack';
import { Text } from '../components/atoms/Typography/Text';
import { BETA_CONTACT_EMAIL } from '../components/auth/BetaAccessNotice/BetaAccessNotice';
import { useTranslation } from '../i18n/useTranslation';
import { getAccountApproval, subscribeAccountApproval } from '../lib/accountApproval';
import './AccountPendingPage.css';

/**
 * Closed beta — /account-pending (public, calls no API): shown after the
 * sign-up code was confirmed and whenever the API refuses a session with 403
 * ACCOUNT_PENDING_APPROVAL / ACCOUNT_REJECTED. The user is already signed out
 * (AuthProvider); this page explains why and how to get in touch. Without a
 * known state (e.g. after a reload) it shows the "waiting" text.
 */
export function AccountPendingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const approval = useSyncExternalStore(subscribeAccountApproval, getAccountApproval, getAccountApproval);
  const rejected = approval === 'rejected';
  const prefix = rejected ? 'auth.approval.rejected' : 'auth.approval.pending';

  return (
    <AuthLayout title={t(`${prefix}.title`)} subtitle={t(`${prefix}.subtitle`)}>
      <Stack gap="4">
        {/* Static page content (the page itself is the reaction) — not announced. */}
        <Alert tone={rejected ? 'warning' : 'info'} live="off" title={t(`${prefix}.alertTitle`)}>
          {t(`${prefix}.body`)}
        </Alert>
        <Text>
          {t('auth.approval.contact')}{' '}
          <a className="account-pending-page__link" href={`mailto:${BETA_CONTACT_EMAIL}`}>
            {BETA_CONTACT_EMAIL}
          </a>
        </Text>
        <Button variant="primary" fullWidth onClick={() => navigate('/login')}>
          {t('auth.approval.toLogin')}
        </Button>
      </Stack>
    </AuthLayout>
  );
}

export default AccountPendingPage;
